<template>
  <!--Contact Section Start-->
  <section class="tj-contact-section" v-if="db">    
    <jumbotron :h1="'Contact Us'" v-if="this.$route.fullPath!='/'" style="margin-top:-150px"/>
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="tj-heading-style">
            <h3>Contact Us</h3>
            <p>{{db.productInfo.contactUsDescription}}</p>
          </div>
        </div>
        <!-- <div class="col-md-8 col-sm-8">
          <div class="form-holder">
            <form @submit.prevent="handleSubmit" class="tj-contact-form">
              <div class="row">
                <div class="col-md-6 col-sm-6">
                  
                  <div class="inner-holder">
                    <label for="name">Name</label>
                    <input
                      placeholder="Enter Your Name"
                      name="name"
                      type="text"
                      id="name"
                      v-model="booking.name"
                      v-validate="'required'"
                      :class="{ 'is-invalid': submitted && errors.has('name') }"
                    />
                  </div>
                  <div
                    v-if="submitted && errors.has('name')"
                    class="invalid-feedback"
                  >* {{ errors.first('name') }}</div>

                  
                </div>
                <div class="col-md-6 col-sm-6 no-pad">
                  
                  <div class="inner-holder">
                    <label for="email">Email</label>
                    <input
                      placeholder="Enter Your Email"
                      name="email"
                      type="email"
                      id="email"
                      v-model="booking.email"
                      v-validate="{ required: true, email:true }"
                      :class="{ 'is-invalid': submitted && errors.has('email') }"
                    />
                  </div>
                  
                  <div
                    v-if="submitted && errors.has('email')"
                    class="invalid-feedback"
                  >* {{ errors.first('email') }}</div>
                </div>
                <div class="col-md-12 col-sm-12">
                  
                  <div class="inner-holder">
                    <label for="phoneNumber">Phoen Number</label>
                    <input
                      placeholder="Your Subject"
                      name="subject"
                      type="text"
                      id="subject"
                      v-model="booking.subject"
                      v-validate="{ required: true}"
                      :class="{ 'is-invalid': submitted && errors.has('subject') }"
                    />
                  </div>
                  
                  <div
                    v-if="submitted && errors.has('subject')"
                    class="invalid-feedback"
                  >* {{ errors.first('subject') }}</div>
                </div>
                <div class="col-md-12 col-sm-12">
                  
                  <div class="inner-holder">
                    <label for="message">Message</label>
                    <textarea
                      name="message"
                      placeholder="Your Message"
                      id="message"
                      v-model="booking.message"
                      v-validate="{ required: true}"
                      :class="{ 'is-invalid': submitted && errors.has('message') }"
                    ></textarea>
                  </div>
                  
                  <p style="white-space: pre-line;">{{ booking.message }}</p> 
                  <div
                    v-if="submitted && errors.has('message')"
                    class="invalid-feedback"
                  >* {{ errors.first('message') }}</div>
                </div>
                <div class="col-md-12 col-sm-12">
                  <div class="inner-holder">
                    <button class="btn-submit" type="submit" id="frm_submit_btn">
                      Send Message
                      <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>-->
        <div class="col-md-12 col-sm-12">
          <div class="address-box">
            <div class="add-info">
              <span class="icon-map icomoon"></span>
              <p>
                <a :href="'https://www.google.com/maps/uv?hl=en&pb=!1s0x48761bae1290d52d:0x310d54df08b94cd9!3m1!7e115!4s/maps/place/whittington%2Bcars/@51.5662892,-0.1348023,3a,75y,147.37h,90t/data%3D*213m4*211e1*213m2*211sP-kWPeUZlbYrJYWPTlx8jA*212e0*214m2*213m1*211s0x48761bae1290d52d:0x310d54df08b94cd9?sa%3DX!5swhittington+cars+-+Google+Search&imagekey=!1e2!2sP-kWPeUZlbYrJYWPTlx8jA&sa=X&ved=2ahUKEwiogO6do5bmAhWxx4UKHUn6DI0Qpx8wE3oECA0QBg'" :target="'_blank'">
                {{db.productInfo.address}}
                </a>
                </p>
            </div>
          </div>
          <div class="address-box">
            <div class="add-info">
              <span class="icon-phone icomoon"></span>
              <p>
                <a :href="'tel:'+db.productInfo.phone">{{db.productInfo.phone}}</a>
              </p>
            </div>
          </div>
          <div class="address-box">
            <div class="add-info">
              <span class="icon-mail-envelope-open icomoon"></span>
              <p>
                <a :href="'mailto:'+db.productInfo.email">{{db.productInfo.email}}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--Contact Section End-->
</template>
<script>
import firebase from "firebase";
import mailer from "../services/mailer.service";
import  jumbotron  from "./jumbotron";
export default {
  data() {
    return {
      db: null,
      vehicleTypes: [
        {
          id: 1,
          title: "Saloon = 4 Passengers x Hand Luggage Only"
        },
        {
          id: 2,
          title: "Estate = 4 Passengers x 4 S/cases"
        },
        {
          id: 3,
          title: "MPV 6 Seater = 6 Passengers x 4 S/cases"
        }
      ],
      booking: {
        name: "",
        email: "",
        phoneNumber: "",
        pickupAddress: "",
        dropOffAddress: "",
        pickupDate: new Date(),
        pickupTime: "",
        dropOffDate: new Date(),
        returnDate: new Date(),
        vehicleTypeId: 0,
        returnTime: "",
        passengers: 4,
        luggage: 1,
        childSeat: false,
        specialInstructions: ""
      },
      submitted: false
    };
  },
  
  components:{jumbotron},
  mounted() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    let that = this;
    var ref = firebase.database().ref();
    ref.on(
      "value",
      function(snapshot) {
        that.db = snapshot.val();
      },
      function(error) {
        // console.log("Error: " + error.code);
      }
    );
  },
  methods: {
    handleSubmit(e) {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          mailer
            .send({
              to: booking.email,
              from: this.db.productInfo.email,
              subject: "'Design Your Model S | Tesla'",
              html:
                "<h1>Have the most fun you can in a car!</h1><p>Get your <b>Tesla</b> today!</p>"
              // "attachments": [
              //   {
              //     "filename": "your-testla.png",
              //     "path": "https://media.gettyimages.com/photos/view-of-tesla-model-s-in-barcelona-spain-on-september-10-2018-picture-id1032050330?s=2048x2048"
              //   }
              // ]
            })
            .then(res => {
              alert(
                "Thank you for contacting us our support team will contact you soon."
              );
            });
        }
      });
    }
  }
};
</script>
<style scoped>
.invalid-feedback {
  color: red;
  padding-bottom: 15px;
}
.is-invalid {
  border: 0.5px solid red;
}
</style>